import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import less from 'less';
import 'font-awesome/css/font-awesome.css'

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)

Vue.use(less)
Vue.prototype.$global = {
  isPc:true,
  path:'/',
  menu:[
    {
      path: '/',
      name: '首页'
    },
    {
      path: '/plan',
      query:{
        scode:2
      },
      name: '实验室规划设计',
      top:{
        title:'实验室规划设计',
        desc:'了解最新公司动态及行业资讯'
      }
    },
    {
      path: '/epc',
      query:{
        scode:1
      },
      name: '实验室EPC（总承包）',
      top:{
        title:'实验室EPC（总承包）',
        desc:'------LABORATORY EPC------'
      }
    },
    {
      path: '/furniture',
      query:{
        scode:12
      },
      name: '实验室家具',
      top:{
        title:'实验室家具',
        desc:''
      }
    },
    {
      path: '/case',
      query:{
        scode:8
      },
      name: '工程案例',
      top:{
        title:'工程案例',
        desc:'服务创造价值、存在造就未来'
      }
    },
    {
      path: '/news',
      query:{
        scode:9
      },
      name: '公司新闻',
      top:{
        title:'公司新闻',
        desc:''
      }
    },
    {
      path: '/service',
      query:{
        scode:5
      },
      name: '服务范围',
      isnotshow: true,
      top:{
        title:'服务范围',
        desc:'------SERVICE------'
      }
    },
    {
      path: '/about',
      query:{
        scode:11
      },
      name: '关于我们',
      id: '1',
      childs:[
        {
          pid: '1',
          path: '/about1',
          query:{
            scode:13
          },
          name: '公司简介',
          top:{
            title:'公司简介',
            desc:''
          }
        },
        {
          pid: '1',
          path: '/about2',
          query:{
            scode:14
          },
          name: '企业文化',
          top:{
            title:'企业文化',
            desc:''
          }
        },
        {
          pid: '1',
          path: '/about3',
          query:{
            scode:15
          },
          name: '联系我们',
          top:{
            title:'联系我们',
            desc:''
          }
        }
      ]
    }
  ]
}
axios.defaults.baseURL = 'https://api.ruilisenlab.com/index.php'
axios.defaults.timeout = 12000
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
